const myProject = require('./myProject');
const envSettings = myProject[myProject.environment];
const serverPagesRoot = envSettings.server + envSettings.rootPath  + "/tiiveysmittaus";
module.exports = {
    fi: {
        home: envSettings.rootPath + "/",
        offerRequest: envSettings.rootPath + "/tarjouspyynto/",
        terms: envSettings.rootPath + "/kayttoehdot/",
        price: envSettings.rootPath + "/hinta/",
        thanks: envSettings.rootPath + "/kiitos/",
        map: serverPagesRoot + "/yritykset/",
        sitePosp: "https://www.posp.fi/",
        sitePospCaption: "Positive Productions Oy",
        siteHankix: "https://www.hankix.fi/",
        siteHankixCaption: "hankix.fi",
        siteIlmanvaihdonhuolto: "https://www.hankiilmanvaihdonhuolto.fi/",
        siteIlmanvaihdonhuoltoCaption: "hankiilmanvaihdonhuolto.fi",
        siteKosteusmittaus: "https://www.hankikosteusmittaus.fi/",
        siteKosteusmittausCaption: "hankikosteusmittaus.fi",
        siteKuntotarkastus: "https://www.hankikuntotarkastus.fi/",
        siteKuntotarkastusCaption: "hankikuntotarkastus.fi",
        siteLampokuvaus: "https://www.hankilampokuvaus.fi/",
        siteLampokuvausCaption: "hankilampokuvaus.fi",
        siteTiiveysmittaus: "https://www.hankitiiveysmittaus.fi/",
        siteTiiveysmittausCaption: "hankitiiveysmittaus.fi",
        headerCityHelsinki: serverPagesRoot + "/helsinki/",
        headerCityEspoo: serverPagesRoot + "/espoo/",
        headerCityTampere: serverPagesRoot + "/tampere/",
        headerCityVantaa: serverPagesRoot + "/vantaa/",
        headerCityOulu: serverPagesRoot + "/oulu/",
        locations : [
            {link: serverPagesRoot + "/espoo/", caption: "Espoo"},
            {link: serverPagesRoot + "/helsinki/", caption: "Helsinki"},
            {link: serverPagesRoot + "/hameenlinna/", caption: "Hämeenlinna"},
            {link: serverPagesRoot + "/hyvinkaa/", caption: "Hyvinkää"},
            {link: serverPagesRoot + "/iisalmi/", caption: "Iisalmi"},
            {link: serverPagesRoot + "/joensuu/", caption: "Joensuu"},
            {link: serverPagesRoot + "/jarvenpaa/", caption: "Järvenpää"},
            {link: serverPagesRoot + "/jyvaskyla/", caption: "Jyväskylä"},
            {link: serverPagesRoot + "/kajaani/", caption: "Kajaani"},
            {link: serverPagesRoot + "/kokkola/", caption: "Kokkola"},
            {link: serverPagesRoot + "/kouvola/", caption: "Kouvola"},
            {link: serverPagesRoot + "/kotka/", caption: "Kotka"},
            {link: serverPagesRoot + "/kuopio/", caption: "Kuopio"},
            {link: serverPagesRoot + "/lahti/", caption: "Lahti"},
            {link: serverPagesRoot + "/lappi/", caption: "Lappi"},
            {link: serverPagesRoot + "/lappeenranta/", caption: "Lappeenranta"},
            {link: serverPagesRoot + "/lohja/", caption: "Lohja"},
            {link: serverPagesRoot + "/mikkeli/", caption: "Mikkeli"},
            {link: serverPagesRoot + "/oulu/", caption: "Oulu"},
            {link: serverPagesRoot + "/pori/", caption: "Pori"},
            {link: serverPagesRoot + "/porvoo/", caption: "Porvoo"},
            {link: serverPagesRoot + "/rauma/", caption: "Rauma"},
            {link: serverPagesRoot + "/rovaniemi/", caption: "Rovaniemi"},
            {link: serverPagesRoot + "/salo/", caption: "Salo"},
            {link: serverPagesRoot + "/seinajoki/", caption: "Seinäjoki"},
            {link: serverPagesRoot + "/tampere/", caption: "Tampere"},
            {link: serverPagesRoot + "/turku/", caption: "Turku"},
            {link: serverPagesRoot + "/vaasa/", caption: "Vaasa"},
            {link: serverPagesRoot + "/vantaa/", caption: "Vantaa"}
        ]
    }
};